import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "locationTypeField", "physicalContent", "onlineContent", "addressField", "venueNameField", "saveVenueCheckbox",
    "latitudeField", "longitudeField", "meetingIdField", "meetingIdInput", "platformDropdownBtn",
    "platformDisplay", "platformField", "platformName", "platformImage", "meetingLinkField", "accessInstructionsField"
  ]

  static values = {
    type: String
  }

  connect() {
    this.initializeLocationPlatform()

    // Set the initial location type field value
    const initialType = this.typeValue || 'physical'
    this.locationTypeFieldTarget.value = initialType
  }

  // Get platform configuration from the data attribute (provided by Rails helper)
  get platformConfig() {
    const platformDropdown = document.querySelector('.platform-dropdown')
    if (platformDropdown && platformDropdown.dataset.platformConfig) {
      try {
        return JSON.parse(platformDropdown.dataset.platformConfig)
      } catch (e) {
        console.error('Error parsing platform config:', e)
      }
    }
    return {}
  }

  switchLocationType(event) {
    const locationType = event.currentTarget.dataset.locationType
    this.locationTypeFieldTarget.value = locationType

    // Clear fields when switching between types
    this.clearFieldsOnSwitch(locationType)
  }

  clearFieldsOnSwitch(selectedType) {
    if (selectedType === 'physical') {
      // Clear online fields when switching to physical
      if (this.hasPlatformFieldTarget) {
        this.platformFieldTarget.value = ''
        this.resetPlatformDisplay()
      }
      // Clear meeting link and id fields
      if (this.hasMeetingLinkFieldTarget) this.meetingLinkFieldTarget.value = ''
      if (this.hasMeetingIdInputTarget) this.meetingIdInputTarget.value = ''
      if (this.hasAccessInstructionsFieldTarget) this.accessInstructionsFieldTarget.value = ''
    } else {
      // Clear physical location when switching to online
      if (this.hasAddressFieldTarget) this.addressFieldTarget.value = ''
      if (this.hasVenueNameFieldTarget) this.venueNameFieldTarget.value = ''
      if (this.hasSaveVenueCheckboxTarget) this.saveVenueCheckboxTarget.checked = false

      // Clear coordinates only if they weren't set by Google Places
      if (this.hasLatitudeFieldTarget) this.latitudeFieldTarget.value = ''
      if (this.hasLongitudeFieldTarget) this.longitudeFieldTarget.value = ''
    }
  }

  // Reset platform dropdown to default state
  resetPlatformDisplay() {
    if (!this.hasPlatformDisplayTarget) return

    const iconElement = this.platformDisplayTarget.querySelector('.platform-icon')
    const textElement = this.platformDisplayTarget.querySelector('.platform-text')

    if (iconElement && textElement) {
      iconElement.innerHTML = ''
      textElement.textContent = 'Select Platform'
      textElement.style.color = '#6c757d'
      textElement.style.fontWeight = '400'

      // Mark button as not selected
      this.platformDropdownBtnTarget.setAttribute('data-selected', 'false')
    }
  }

  // Handle platform selection from dropdown
  selectPlatform(event) {
    event.preventDefault()
    const platform = event.currentTarget.dataset.platform

    // Update the hidden field
    if (this.hasPlatformFieldTarget) this.platformFieldTarget.value = platform

    this.updatePlatformDisplay(platform)
    this.handlePlatformChange(platform)
  }

  // Update the dropdown button display
  updatePlatformDisplay(platform) {
    if (!this.hasPlatformDisplayTarget || !platform) return

    const config = this.platformConfig[platform]
    if (config) {
      const iconElement = this.platformImageTarget
      const textElement = this.platformNameTarget

      if (iconElement && textElement) {
        iconElement.innerHTML = `<img src="${config.icon}" style="width: 24px; height: 24px; object-fit: contain;" />`
        textElement.textContent = config.name
        textElement.style.color = '#333'
        textElement.style.fontWeight = '500'

        // Mark button as selected
        this.platformDropdownBtnTarget.setAttribute('data-selected', 'true')
      }
    }
  }

  handlePlatformChange(platform) {
    if (this.hasMeetingIdFieldTarget) this.meetingIdFieldTarget.classList.toggle('d-none', platform !== 'zoom')
  }

  initializeLocationPlatform() {
    if (this.hasPlatformFieldTarget && this.platformFieldTarget.value) {
      this.handlePlatformChange(this.platformFieldTarget.value)
    }
  }
} 